import { render, staticRenderFns } from "./show-component.vue?vue&type=template&id=27fa3422&scoped=true"
import script from "./show-component.vue?vue&type=script&lang=js"
export * from "./show-component.vue?vue&type=script&lang=js"
import style0 from "./show-component.vue?vue&type=style&index=0&id=27fa3422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fa3422",
  null
  
)

export default component.exports